import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

// SAVE Pharmacy Item (POST)
export const savePharmacyItem = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/pharmacy-items`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// GET Pharmacy Items (LIST)
export const getPharmacyItems = (params?: any) => {
  return new Promise((resolve, reject) => {
    let query = new URLSearchParams();
    if (params) {
      for (let key in params) {
        if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
          query.set(key, params[key]);
        }
      }
    }
    const queryString = query.toString();
    const url = queryString 
      ? `${BASE_URL}/api/v1/pharmacy-items?${queryString}`
      : `${BASE_URL}/api/v1/pharmacy-items`;
    
    api
      .get(url)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// GET Pharmacy Item by ID
export const getPharmacyItemById = (id: number) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/pharmacy-items/${id}`)
      .then((res) => resolve(res.data.data)) 
      .catch((err) => reject(err));
  });
};

// UPDATE Pharmacy Item (PUT)
export const updatePharmacyItem = (id: number, payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/pharmacy-items/${id}`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};
